// Package imports:
import { faCommentQuestion, faWindowMinimize, faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useRef, useState } from 'react';
import { GET_STAGING_STRING } from '../../services/config';
import Cookies from 'universal-cookie';
import Overlay from 'react-bootstrap/Overlay';
import Popover from 'react-bootstrap/Popover';


const ChatBot: React.FC = () => {

    const cookies = new Cookies();
    // if cookie is not found display meswsage
    const [displayMessage, setDisplayMessage] = useState(!cookies.get('_KeldanCookieChatbot'));
    // isMounted: iframe exists in DOM (session alive); isOpen: window is visible; isBubbleHidden: bubble is hidden after close
    const [isMounted, setIsMounted] = React.useState(false);
    const [isOpen, setIsOpen] = React.useState(false);
    const [isBubbleHidden, setIsBubbleHidden] = React.useState(false);
    const bubbleRef = useRef<HTMLDivElement>(null);

    const handleSetChatBotMessageCookie = () => {
        let today = new Date();
        cookies.set('_KeldanCookieChatbot', 1, { expires: new Date(today.setMonth(today.getMonth() + 6)), path: '/' });
        setDisplayMessage(false)
    }

    const handleBubbleClick = () => {
        displayMessage && handleSetChatBotMessageCookie();
        setIsBubbleHidden(false);
        if (!isMounted) {
            // Mount first so the element enters the DOM with is-closed,
            // then trigger the open transition on the next paint
            setIsMounted(true);
            requestAnimationFrame(() => requestAnimationFrame(() => setIsOpen(true)));
        } else {
            // Restore minimized window (session preserved)
            setIsOpen(true);
        }
    }

    const handleMinimize = () => setIsOpen(false);

    const handleClose = () => {
        // Keep bubble hidden throughout, animate window closed, then unmount
        setIsBubbleHidden(true);
        setIsOpen(false);
        setTimeout(() => setIsMounted(false), 200);
    }

    return (
        <div className="KCL_chatBot">
            <div ref={bubbleRef} className={`chatBot-bubble${isOpen || isBubbleHidden ? ' is-hidden' : ''}`} onClick={handleBubbleClick}>
                <FontAwesomeIcon icon={faCommentQuestion} className='fa-icon' />
            </div>
            <Overlay target={bubbleRef} show={displayMessage} placement='top-end' transition={true}>
                {(props) => (
                    <Popover {...props} className='KCL_chatBot-popover'>
                        <Popover.Body>Daginn, ég er spjallmenni og get svarað spurningum um þjónustur Keldunar.</Popover.Body>
                    </Popover>
                )}
            </Overlay>
            {isMounted && (
                <div className={`chatBot-message-window${isOpen ? ' is-open' : ' is-closed'}`}>
                    <div className='topBar'>
                        <span className='topBar--title'> Keldan - Spjallmenni</span>
                        <div className='topBar--icons'>
                            <div className='topBar--icons-wrappers'>
                                <FontAwesomeIcon icon={faWindowMinimize} className='fa-icon' onClick={handleMinimize} />
                            </div>
                            <div className='topBar--icons-wrappers'>
                                <FontAwesomeIcon icon={faTimes} className='fa-icon' onClick={handleClose} />
                            </div>
                        </div>
                    </div>
                    <iframe title='Keldan_chatbot' src={`https://chatbot${GET_STAGING_STRING('-')}.kodi.is/keldan-chatbot`} />
                </div>
            )}
        </div>
    );
}

export default ChatBot;
